import React from "react";
import { Box, Chip, Slider, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import BearSvg from "@/assets/svg/BearSvg";
import BullSvg from "@/assets/svg/BullSvg";
import { stylesSentimentSliderWithChips as style } from "./styleSentimentSliderWithChips";
type Props = {
  slider: number;
  setSlider: (value: number) => void;
  chipSelect: string[];
  handleChipClick: (chip: string) => void;
};

const SentimentSliderWithChips: React.FC<Props> = ({
  slider,
  setSlider,
  chipSelect,
  handleChipClick,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: "800px",
        height: "94px",
        borderRadius: "12px",
        padding: "20px",
        gap: "26px",
        bgcolor: "#FBFBFB",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          width: "761px",
          height: "54px",
        }}
      >
        <Stack
          direction="row"
          alignItems="center"
          sx={{
            width: "280px",
            height: "54px",
            gap: "26px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: 64,
              gap: "6px",
            }}
          >
            <BearSvg width={42} height={23} big />
            <Typography color={theme.palette.custom.blueGray900} fontWeight={500} variant="body2">
              Strong sell
            </Typography>
          </Box>
          {/* Slider */}
          <Box sx={{ position: "relative", width: 100 }}>
            <Slider
              value={slider}
              valueLabelDisplay="auto"
              onChange={(_e, value) => setSlider(value as number)}
              sx={{
                width: "100%",
                height: 4,
                "& .MuiSlider-thumb": {
                  width: 12,
                  height: 12,
                  backgroundColor: "#FFFFFF",
                  border: "1px solid #0000001A",
                  boxShadow: "0px 2px 4px 0px #0000001A",
                },

                "& .MuiSlider-track": {
                  backgroundColor: "transparent !important",
                  border: "none",
                },

                "& .MuiSlider-rail": {
                  backgroundColor: "#C6CACE",
                  opacity: 1,
                },
                "& .MuiSlider-valueLabel": {
                  width: "26px",
                  height: "20px",
                  backgroundColor: "#2a2d31",
                  borderRadius: "6px",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: 500,
                },
              }}
              min={-5}
              max={5}
            />

            <Typography
              sx={{
                position: "absolute",
                bottom: -10,
                left: "50%",
                transform: "translateX(-50%)",
                fontSize: "12px",
              }}
            >
              Neutral
            </Typography>
          </Box>

          {/* Bull */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: 64,
              gap: "6px",
            }}
          >
            <BullSvg width={42} height={23} />
            <Typography color={theme.palette.custom.blueGray900} fontWeight={500} variant="body2">
              Strong buy
            </Typography>
          </Box>
        </Stack>

        <Stack
          direction="row"
          alignItems="center"
          sx={{
            width: "223px",
            height: "34px",
            gap: "8px",
          }}
        >
          <Chip
            label="#fundamental"
            clickable
            onClick={() => handleChipClick("#fundamental")}
            sx={style.chipStyle(chipSelect, "#fundamental")}
          />
          <Chip
            label="#technical"
            clickable
            onClick={() => handleChipClick("#technical")}
            sx={style.chipStyle(chipSelect, "#technical")}
          />
        </Stack>
      </Stack>
    </Box>
  );
};

export default SentimentSliderWithChips;
